export const VANILLA = 'vanilla';
export const MANDATORY = 'mandatory';
